import { trigger, state, style, AUTO_STYLE, transition, animate } from '@angular/animations';
import { Component, output, input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DEFAULT_DURATION } from '../static-sub-menu/static-sub-menu.component';
import { MenuItems } from '../../dynamic-header/category/header-data';
import { HeaderLayout } from '../../dynamic-header/dynamic-header.component';
import { IMAGE_URLS } from 'src/app/core/constants/image-source';

@Component({
  selector: 'app-static-sub-menu-child',
  templateUrl: './static-sub-menu-child.component.html',
  styleUrls: ['./static-sub-menu-child.component.scss'],
  standalone: true,
  animations: [
    trigger('collapse', [
      state('false', style({ height: AUTO_STYLE, visibility: AUTO_STYLE })),
      state('true', style({ height: '0', visibility: 'hidden' })),
      transition('false => true', animate(DEFAULT_DURATION + 'ms ease-in')),
      transition('true => false', animate(DEFAULT_DURATION + 'ms ease-out'))
    ])
  ],
  imports: [CommonModule]
})
export class StaticSubMenuChildComponent {
  readonly menuCollapseIcon = input<string>("");
  readonly menuItem = input.required<MenuItems>();
  readonly collapsed = input<boolean>(false);
  readonly headerLayout = input<string>('default');

  // Computed property to check if layout is headerLayout12
  readonly isLayout12 = computed(() => this.headerLayout() === HeaderLayout.headerLayout12);
  
  HeaderLayout = HeaderLayout; // Exposed enum to template
  IMAGE_URLS = IMAGE_URLS;

  // Update output to use Angular 20 output() function
  hideMenu$ = output<any>();

  onHideMenu() {
    this.hideMenu$.emit(true);
  }

  toggle() {
    // Note: Since collapsed is now a readonly input, toggle logic needs to be handled by parent
  }

  expand() {
    // Note: Since collapsed is now a readonly input, this needs to be handled by parent
  }

  collapse() {
    // Note: Since collapsed is now a readonly input, this needs to be handled by parent
  }

}

